<template>
  <div>
    <img
      loading="lazy"
      src="../../assets/index.jpg"
      alt="Smiley face"
      width="100%"
      height="100%"
    />
  </div>
</template>

<script>
export default {};
</script>
